import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import PrinciplesSection from './components/PrinciplesSection';
import PhilosophySection from './components/PhilosophySection';
import InnovationSection from './components/InnovationSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <PrinciplesSection />
      <PhilosophySection />
      <InnovationSection />
      <ContactSection />
    </main>
  );
}